import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { closeCart, openCart, selectCartIsOpen } from '../../store/slices/cartSlice'
import { RootState } from '../../store/store'
import CartSidebar from '../CartSidebar/CartSidebar'
import styles from './Header.module.css'

const CartIcon: React.FC = () => {
  const dispatch = useDispatch()
  const isCartOpen = useSelector(selectCartIsOpen)
  const cartItems = useSelector((state: RootState) => state.cart.items)

  const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0)

  return (
    <>
      <button
        className={styles.cartAction}
        onClick={() => dispatch(openCart())}
        aria-label={totalItems > 0 ? `Кошик, ${totalItems}` : 'Кошик'}
      >
        <div className={styles.cartContainer}>
          <svg
            className={styles.cartIcon}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M15.0003 12.5H5.83366L4.58366 5H17.5003L15.0003 12.5Z" fill="white" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1.66699 2.5C1.66699 2.03976 2.04009 1.66666 2.50033 1.66666H4.16699C4.57436 1.66666 4.92202 1.96117 4.98899 2.363L5.2896 4.16666H17.5003C17.7682 4.16666 18.0197 4.29543 18.1764 4.51274C18.333 4.73005 18.3756 5.0094 18.2909 5.26352L15.7909 12.7635C15.6775 13.1038 15.359 13.3333 15.0003 13.3333H5.83366C5.42629 13.3333 5.07863 13.0388 5.01166 12.637L3.46105 3.33333H2.50033C2.04009 3.33333 1.66699 2.96023 1.66699 2.5ZM5.56738 5.83333L6.5396 11.6667H14.3997L16.3441 5.83333H5.56738Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.00033 16.6667C5.00033 15.7462 5.74652 15 6.66699 15C7.58747 15 8.33366 15.7462 8.33366 16.6667C8.33366 17.5871 7.58747 18.3333 6.66699 18.3333C5.74652 18.3333 5.00033 17.5871 5.00033 16.6667Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.5003 16.6667C12.5003 15.7462 13.2465 15 14.167 15C15.0875 15 15.8337 15.7462 15.8337 16.6667C15.8337 17.5871 15.0875 18.3333 14.167 18.3333C13.2465 18.3333 12.5003 17.5871 12.5003 16.6667Z"
              fill="white"
            />
          </svg>
        </div>
        {totalItems > 0 && <div className={styles.cartBadge}>{totalItems}</div>}
      </button>

      <CartSidebar isOpen={isCartOpen} onClose={() => dispatch(closeCart())} />
    </>
  )
}

export default CartIcon
